// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__8Lxq1","content":"Modal_content__XuOwy","button":"Modal_button__dzUly"};